<template>
  <tr>
    <td colspan="2" class="pr-0 pt-0 pb-0" :style="{'padding-left': `${depth*10}px`}">
      <table class="table table-borderless">
        <tr>
          <td>{{node.name}}</td>
          <td>
            <div class="d-flex justify-content-end" v-if="node.name !== '/'">
              <div class="btn-group">
                <a class="btn btn-sm btn-primary" @click="$emit('edit', node)" href="#"><font-awesome-icon icon="fas fa-edit" /></a>
                <a class="btn btn-sm btn-danger" @click="$emit('delete', node.id)" href="#"><font-awesome-icon icon="fas fa-trash" /></a>
              </div>
            </div>

          </td>
        </tr>
        <TreeContainer
          v-for="child in node.children"
          :key="child.name"
          :node="child"
          :depth="depth+1"

          @edit="$emit('edit', $event)"
          @delete="$emit('delete', $event)"
           />
      </table>
    </td>
  </tr>
</template>

<script>
export default {
  name: "TreeContainer",
  props: {
    node: Object,
    depth: {
      type: Number,
      default: 0
    }
  }
}
</script>
